import Vue from 'vue';
import VueI18n from 'vue-i18n';
import english from '@/locales/en-US';
import spanish from '@/locales/es-ES';
import french from '@/locales/fr-FR';
import korean from '@/locales/ko-KR';
import { merge } from 'lodash';
Vue.use(VueI18n);

const messages = {
  en: merge(english.localeAntd, english.messages),
  es: merge(spanish.localeAntd, spanish.messages),
  fr: merge(french.localeAntd, french.messages),
  ko: merge(korean.localeAntd, korean.messages),
};

const i18n = new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  // set locale messages
  messages,
});
Vue.prototype.locale = i18n;
export default i18n;
